import http from '../../../Services/api.laravel.http';

export const ReportsService = {
    generateReport: (id) => http.get('/admin/reports/generate/' + id),
    paginateWithSearchReports: (formParams) =>
        http.post('/admin/reports/search', formParams),
    createReport: (formParams) => http.post('/admin/reports', formParams),
    reportChecker: (id) => http.get(`/admin/reports/job-status/${id}`),
    testReport: (formParams) =>
        http.post('/admin/reports/test-report', formParams),
    paginateWithSearchDownloads: (formParams) =>
        http.post('/admin/reports/search/downloads', formParams),
    ArchiveReport: (formParams) =>
        http.post('/admin/reports/archives/list', formParams),
    ArchiveDownload: (formParams) =>
        http.post('/admin/reports/archives/download/list', formParams),
};
